/**
 * SummaryReportService
 *
 * Interface-first CRUD for SummaryReport entities. Selects the implementation; the
 * localStorage one is kept beside it as the fallback.
 */

import type { SummaryReport } from '../components/SummaryReports/types';
import { SummaryReportServiceArcGIS } from './SummaryReportServiceArcGIS';

// ─── Interface ───────────────────────────────────────────────────────────────

/**
 * Async throughout because the Feature Service implementation behind this can't be sync.
 * Save and update return the stored entity because layer 31's key (GlobalID) is
 * server-assigned — a new report's id is only known from the write response.
 */
export interface SummaryReportServiceInterface {
    saveSummaryReport(report: SummaryReport): Promise<SummaryReport>;
    getSummaryReportById(id: string): Promise<SummaryReport | null>;
    getAllSummaryReportsForUser(userId: string): Promise<SummaryReport[]>;
    updateSummaryReport(report: SummaryReport): Promise<SummaryReport>;
    deleteSummaryReport(id: string): Promise<void>;
}

// ─── Exported Implementation ─────────────────────────────────────────────────

/** Swap this back to the localStorage implementation to fall off the Feature Service. */
export const SummaryReportService: SummaryReportServiceInterface = SummaryReportServiceArcGIS;
